import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeFuelingServiceImage } from '../../api/fueling-service.ts';
import { RemoveFuelingServiceImageRequest } from '../../api/requests/fueling-service-request.ts';

export default function useRemoveFuelingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof removeFuelingServiceImage>>,
  Error,
  RemoveFuelingServiceImageRequest
> {
  return useMutation({
    mutationFn: removeFuelingServiceImage,
  });
}
